import {get, post, postJson,deleteApi, postBlob} from './axios2'
import {imagePost} from './axios3'

const RESOURCE_BASE_PATH = '/activity-common';

// 分页获取活动列表
export const getList = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);


//抖音下单有礼 创建
export const addxdList = p => postJson(`${RESOURCE_BASE_PATH}/save`, p);

//抖音下单有礼  查询 
export const purchaseActivityDetail = activityId => get(`${RESOURCE_BASE_PATH}/detail/${activityId}`,)

// 检查活动时间是否合法
export const activityCommonCheck = p => postJson(`${RESOURCE_BASE_PATH}/check`,p)

// 获取活动链接
export const activityUrl = p => get(`${RESOURCE_BASE_PATH}/activity-url`,p)

//互动活动 保存至草稿
export const draftSave = p => postJson(`${RESOURCE_BASE_PATH}/draft/save`, p);

// 分页获取活动草稿列表
export const getDraftList = p => postJson(`${RESOURCE_BASE_PATH}/draft/list`, p);

// 删除活动草稿
export const deleteDraft = activityId => deleteApi(`${RESOURCE_BASE_PATH}/draft/${activityId}`);

// 获取活动草稿详情
export const getDraftDetail = activityId => get(`${RESOURCE_BASE_PATH}/draft/detail/${activityId}`)

// 上传图片
export const uploadpic = p => imagePost('/public/upload', p);

// 修改奖品库存
export const updatePriceAmount = p => postJson(`${RESOURCE_BASE_PATH}/updatePriceAmount`, p);

/**获取自选皮肤 */
export const getSkinPage = p => postJson(`${RESOURCE_BASE_PATH}/getSkinPage`, p);

// 获取活动奖品总览列表
export const getPrizeSummary = p => get(`/effect/activity/prize/summary`, p);

// 导出活动数据列表
export const exportActivityList = p => postBlob(`/customer-api/effect/activity/effect/list/export`, p);

// 更新活动奖项信息
export const updateActivityPrizeInfo = p => postJson(`/activity-common/updateActivityPrizeInfo`, p)

//查看优惠券领奖详情
export const getCouponOrderPage = p => postJson(`/effect/coupon/order/page`, p)
// 获取活动总览字段配置
export const getActivityDataOverviewConfig = p => get(`/activity-common/fieldConfig/getBySellerId`, p);

//互动管理-活动复盘列表
export const getActivityData = p => postJson(`/effect/getActivityEffectDetailList`, p)

//保存或者更新活动总览字段配置
export const saveActivityDataOverviewConfig = p => postJson(`/activity-common/fieldConfig/saveOrUpdate`, p)

//互动管理-导出活动复盘列表
export const exportActivityData = p => postBlob(`/customer-api/effect/activityEffectDetailList/export`, p)

// 同步关联订单状态
export const syncActivityOrderStatus = p => postJson(`/activity-common/syncActivityOrderStatus`, p)

// 获取同步订单结果
export const getActivityOrderSyncResult = p => postJson(`/activity-common/getActivityOrderSyncResult`, p)

// 白名单分页查询
export const whiteListPage = p => postJson(`/activity-common/whitelist/page`, p);

// 白名单添加
export const whiteListAdd = p => postJson(`/activity-common/whitelist/add`, p);

// 白名单删除
export const whiteListDelete = p => postJson(`/activity-common/whitelist/delete`, p);

// 白名单导入
export const whiteListImport = (id, p) => postJson(`/activity-common/whitelist/import?activityId=${id}`, p);